import { render, staticRenderFns } from "./RankInstrutores.vue?vue&type=template&id=242635b0&scoped=true"
import script from "./RankInstrutores.vue?vue&type=script&lang=js"
export * from "./RankInstrutores.vue?vue&type=script&lang=js"
import style0 from "./RankInstrutores.vue?vue&type=style&index=0&id=242635b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242635b0",
  null
  
)

export default component.exports